module.exports = __webpack_public_path__ + "static/img/slide_5_fr.d627c07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/live-hr-advice/slider/slide_5_fr.png
// module id = Pp9W
// module chunks = 0